import { Link } from "react-router-dom";
import { SITE } from "@/constants/site";
import { Logo } from "@/components/Navbar";

export const Footer = () => (
  <footer
    className="bg-[#070b16] text-[#9cb4d8] py-16 border-t border-[#203154]"
    data-testid="site-footer"
  >
    <div className="max-w-6xl mx-auto px-6">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
        <div className="md:col-span-2">
          <div className="mb-4">
            <Logo className="h-9 w-auto" />
          </div>
          <p className="text-xs text-[#9cb4d8] max-w-sm leading-relaxed mb-4">
            Enterprise software development, IT services, and premier career academy in Telangana.
          </p>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-white mb-4">
            Curriculums
          </div>
          <ul className="space-y-2 text-xs">
            <li>
              <Link to="/courses" className="hover:text-white transition-colors" data-testid="footer-link-ai">
                AI &amp; Generative Models
              </Link>
            </li>
            <li>
              <Link to="/courses" className="hover:text-white transition-colors" data-testid="footer-link-ds">
                Data Science &amp; BI
              </Link>
            </li>
            <li>
              <Link to="/courses" className="hover:text-white transition-colors" data-testid="footer-link-sap">
                SAP S/4HANA
              </Link>
            </li>
            <li>
              <Link to="/courses" className="hover:text-white transition-colors" data-testid="footer-link-oracle">
                Oracle DB &amp; Cloud
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-white mb-4">Contact</div>
          <p className="text-xs text-[#9cb4d8] leading-relaxed" data-testid="footer-contact">
            {SITE.address}
            <br />
            <a href={SITE.phoneHref} className="text-[#38bdf8] font-mono hover:text-white transition-colors" data-testid="footer-phone">
              {SITE.phone}
            </a>
            <br />
            <a href={`mailto:${SITE.email}`} className="text-[#38bdf8] font-mono hover:text-white transition-colors" data-testid="footer-email">
              {SITE.email}
            </a>
          </p>
        </div>
      </div>
      <div className="pt-8 border-t border-[#203154] flex flex-col md:flex-row items-center justify-between text-xs text-[#4b658d] gap-4">
        <div>&copy; 2025 Adipurusa Infotech Private Limited. All rights reserved.</div>
        <div className="font-mono text-[11px] text-[#38bdf8]">Training · Development · IT Services</div>
      </div>
    </div>
  </footer>
);
